import React from 'react'
import { Accordion } from 'react-bootstrap'
import './faq.css'
import CardContainer from '../container/CardContainer'

const FAQ: React.FunctionComponent<any> = ({FAQData}) => {
    
    interface faqItemInterface {
        id: number,
        question: string,
        answer: string
    }

    if (FAQData.length) {
        return <Accordion defaultActiveKey={"1"} className='mf-faq'>
            {
                FAQData.map((item: faqItemInterface, index: number) => (
                    <CardContainer key={`${index}`}>
                        <Accordion.Item className='mf-faq-item bg-white' eventKey={`${index + 1}`}>
                            <Accordion.Header>
                                <p className='text-primary-color font-16 weight-500 pe-3 mb-0'>{ item.question }</p>
                            </Accordion.Header>
                            <Accordion.Body className='text-primary-color font-14 weight-400 pt-0 faq-body'>
                                { item.answer }
                            </Accordion.Body>
                        </Accordion.Item>
                    </CardContainer>
                ))
            }
        </Accordion> 
    } else {
        return <p className="mb-0 text-center font-14 text-primary-color weight-500 text-capitalize">No FAQ data available...</p>
    }


}

export default FAQ